import { Button, PageHeader } from '@ksyos/design-system';
import { Link as ReactRouterLink, useNavigate } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { fetchJson } from '@frontend/store/fetch';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization, hasOneAuthorization } from '@frontend/utils';
import type { DeclarationActivity } from '../../declarationActivities/declarationActivity';
import { ServiceDeclarationActivityListTable } from './ServiceDeclarationActivityListTable';

type ServiceDeclarationActivityListProps = {
    serviceId: string;
};

export function ServiceDeclarationActivityList(props: ServiceDeclarationActivityListProps) {
    const navigate = useNavigate();

    const [serviceDeclarationActivities, setServiceDeclarationActivities] = useState<DeclarationActivity[]>([]);
    const {
        serviceDeclarationRules: { addDeclarationActivity, declarationActivities },
    } = getSelectedLanguage();
    assertHasAuthorization(ManagerAuthorization.servicesRead);

    useEffect(() => {
        load(props.serviceId);
    }, [props.serviceId]);

    return (
        <>
            <PageHeader
                action={
                    hasOneAuthorization(ManagerAuthorization.serviceAddEdit) && (
                        <Button
                            as={ReactRouterLink}
                            iconLeft="add"
                            to={`/declarationActivities/add?serviceId=${props.serviceId}&returnTo=services`}
                        >
                            {addDeclarationActivity}
                        </Button>
                    )
                }
                title={declarationActivities}
            />
            <ServiceDeclarationActivityListTable
                items={serviceDeclarationActivities}
                onEdit={handleEdit}
                onRemove={handleRemove}
            />
        </>
    );

    async function load(serviceId: string) {
        const url = `/api/serviceDeclarationActivities?serviceId=${serviceId}`;
        const result = await fetchJson(url, 'GET');
        setServiceDeclarationActivities(result.json.items);
    }

    async function handleRemove(id: string) {
        const url = `api/serviceDeclarationActivities/${id}`;
        await fetchJson(url, 'DELETE');
        await load(props.serviceId);
    }

    function handleEdit(activityId: string) {
        return navigate(`/declarationActivities/${activityId}/edit?serviceId=${props.serviceId}&returnTo=services`);
    }
}
